import { Link } from "@inertiajs/react";
import { ShareButton } from "./ShareButton";
import { Button } from "react-bootstrap";

export default function RegisButton({
    isPreview,
    eventDay,
    openRegisDay,
    hours,
    minutes,
    seconds,
    remainingTicketQuota,
    slug,
    accessCode
}) {
    return (
        <div className="row justify-content-between align-items-center">
            <div className="col-sm-10 pr-0 col-9">
                {isPreview ? (
                    <Button
                        role="button"
                        disabled={isPreview}
                        className={`btn btn-main-blue btn-block shadow-none w-100 btn-danger ${eventDay < 0 ||
                                remainingTicketQuota <= 0 ||
                                (openRegisDay <= 0 &&
                                    hours <= 0 &&
                                    minutes <= 0 &&
                                    seconds <= 0)
                                ? "disabled"
                                : null
                            }`}
                    >
                        Daftar Sekarang
                    </Button>
                ) : (
                    <Link
                        role="button"
                        href={accessCode?`/event/private/${accessCode}/select-ticket`:`/event/${slug}/select-ticket`}
                        className={`btn btn-main-blue btn-block shadow-none w-100 ${eventDay < 0 ||
                                remainingTicketQuota <= 0 ||
                                (openRegisDay <= 0 &&
                                    hours <= 0 &&
                                    minutes <= 0 &&
                                    seconds <= 0)
                                ? "disabled"
                                : null
                            }`}
                    >
                        Daftar Sekarang
                    </Link>
                )}
            </div>
            <div className="col-sm-2 col-3">
                <ShareButton isDisabled={isPreview} />
            </div>
        </div>
    )
}